import "./custom.css";
import { useCallback, useEffect, useState } from "react";
// library ----------------------------------
import { Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
// Components -------------------------------
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import WidgetsButton from "../../../components/Widgets/button";
import Timeline from "./TimeLine";
import DownloadCard from "../../../components/DownloadCard";
import FileDrop from "./FileDrop";
// Icon -------------------------------------
import { HiOutlineBriefcase } from "react-icons/hi";
import { TbCubeSpark } from "react-icons/tb";
import { TbCube } from "react-icons/tb";
import { FiPlus } from "react-icons/fi";
import { TbReportAnalytics } from "react-icons/tb";

// Redux -----------------------------------
import { useDispatch, useSelector } from "react-redux";
import {
  commonGetData,
  commonSaveData,
  initState,
} from "../../../redux/slices/commonSlice";
import {
  fetchBranchData,
  initBranchState,
} from "../../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../../redux/slices/departmentSlice";
import {
  fetchDesignationList,
  initDesigState,
} from "../../../redux/slices/designationSlice";
import {
  getEmployeeTypeListPath,
  updateEmployementDetailsPath,
  updatePastEmployementDetailsPath,
} from "../../../services/config";
import { HasPermission } from "../../../services/hasPermission";

const paginationPageSize = 10;
const paginationPageSizeSelector = [10, 20, 50, 100];

const CustomDetails = ({ user, userDetails, commonState }) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.common);
  const branchState = useSelector((state) => state.branch);
  const departmentState = useSelector((state) => state.department);

  const [empTypeList, setEmpTypeList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  const [dataList, setDataList] = useState([]);

  const [employeeDetails, setEmployeeDetails] = useState({
    staffId: userDetails[0] !== undefined ? userDetails[0].staffId : "",
    department: userDetails[0].department,
    employee_type: userDetails[0].emp_role,
    date_of_joining: userDetails[0].date_of_join,
    employee_id: userDetails[0].personalDetails.empId,
    job_title: userDetails[0].job_title,
    official_email: userDetails[0].official_email,
    esi_number: userDetails[0].esi_number,
    pf_number: userDetails[0].pf_number,
  });

  const getEmpList = useCallback(() => {
    dispatch(commonGetData(getEmployeeTypeListPath));
    dispatch(fetchBranchData(user.user_id));
    dispatch(fetchDepartmentData(user.user_id));
  }, []);

  useEffect(() => {
    getEmpList();
  }, []);

  useEffect(() => {
    if (state.commonGetSuccess) {
      const newArr = state.commonGetData?.map((v) => {
        return { label: v.type_name, value: v.employeeTypeId };
      });
      setEmpTypeList(newArr);
    }

    if (departmentState.depGetSuccess) {
      const newArr = departmentState.depGetData?.map((v) => {
        return { label: v.department_name, value: v.departmentId };
      });
      setDepartmentList(newArr);
      dispatch(initDepartState());
    }
  }, [state.commonGetSuccess, departmentState.depGetSuccess]);

  useEffect(() => {
    if (branchState.brnGetSuccess) {
      if (
        branchState.brnGetData &&
        branchState.brnGetData.length > 0 &&
        Array.isArray(branchState.brnGetData)
      ) {
        const newArr = branchState.brnGetData.map((v) => {
          return { label: v.branch_name, value: v.branchId };
        });
        const sortArr = newArr.sort((a, b) => (a.value < b.value ? -1 : 1));
        setBranchList(sortArr);
      }
      dispatch(initBranchState());
    }
  }, [branchState.brnGetSuccess]);

  const EmployeeRecords = [
    {
      name: "employee_id",
      label: "Employee Id",
      placeholder: "Enter Employee Id",
    },
    { name: "job_title", label: "Job Title", placeholder: "Enter Job Title" },
    {
      name: "branch",
      label: "Branches",
      placeholder: "Enter Branches",
      isMulti: true,
      chi: branchList,
    },
    {
      name: "department",
      label: "Departments",
      placeholder: "Enter Departments",
      chi: departmentList,
    },
    {
      name: "employee_type",
      label: "Employment Type",
      placeholder: "Enter Employee Type",
      chi: empTypeList,
    },
    { name: "date_of_joining", label: "Date of joining", type: "date" },
    {
      name: "official_email",
      label: "Office Email Id",
      placeholder: "Enter Office Email Id",
    },
  ];

  const savedBranch = userDetails[0].branch.split(",");
  const brnIndex =
    savedBranch !== undefined
      ? savedBranch.map((v) => {
          return branchList.findIndex((obj) => {
            return parseInt(obj.value) === parseInt(v);
          });
        })
      : [];

  const heading = [
    {
      headerName: "SNo",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 60,
      pinned: "left",
    },
    {
      headerName: "Type",
      field: "accountType",
      pinned: "left",
      cellRenderer: (row) => {
        return <div>{row.data.accountType == "1" ? "Saving" : "Current"}</div>;
      },
    },
    {
      headerName: "Model/Details",
      field: "bankAccountNumber",
    },
    {
      headerName: "Assert ID",
      field: "bankBranch",
    },
    {
      headerName: "Issued Date",
      field: "bankIfsc",
    },
    {
      headerName: "Status",
      field: "bankName",
    },

    {
      headerName: "Return Date",
      field: "bankName",
    },

    {
      headerName: "Action",
      field: "bankName",
    },
  ];
  const [dialogForm, setDialogForm] = useState(false);
  const [formType, setFormType] = useState("");

  const handleFormType = (type) => {
    setFormType(type);
    setDialogForm(true);
  };

  const handelChange = ({ target: { name, value } }) => {};

  const preSubmit = () => {
    document.getElementById("submit-btn-bs-dt").click();
  };

  const handelSubmit = (event) => {};

  return (
    <>
      <Row className="p-l-r-10">
        <Col sm="6" className="mb-3">
          <Widgets
            icon={
              <WidgetsIcon
                icon={<HiOutlineBriefcase />}
                title="Employment Details"
              />
            }
            body={
              <Row className="mt-2">
                {EmployeeRecords.map((item, i) => (
                  <Col sm="12">
                    <div className="flex-space-between">
                      <span className="label-text">{item.label}</span>
                      <span className="value-text">
                        {item.isMulti && item.chi
                          ? brnIndex?.map((r) => branchList[r]?.label)
                          : !item.isMulti && item.chi
                          ? item.chi.length > 0
                            ? item.chi.map((v, i) => {
                                return employeeDetails[item.name] == v.value
                                  ? v.label
                                  : null;
                              })
                            : null
                          : employeeDetails[item.name]}
                      </span>
                    </div>
                  </Col>
                ))}
              </Row>
            }
          />
        </Col>
        <Col sm="6" className="mb-3">
          <Widgets
            icon={
              <WidgetsIcon icon={<TbCubeSpark />} title="Asserts Activity" />
            }
            body={<Timeline />}
          />
        </Col>
        <Col sm="12" className="mb-3">
          <Widgets
            icon={<WidgetsIcon icon={<TbCube />} title="Asserts Details" />}
            button={
              HasPermission("Employee", "create") &&
              <WidgetsButton
                type="button"
                variant="dark"
                text="Add Asserts"
                icon={<FiPlus className="btn-icon" />}
                onClick={() => handleFormType("asserts")}
              />
            }
            body={
              <div
                className="ag-theme-quartz custom-grid mt-3"
                style={{ height: "300px", width: "100%" }}
              >
                <AgGridReact
                  rowData={Array.isArray(dataList) ? dataList : []}
                  columnDefs={heading}
                  omLayout="autoHeight"
                  pagination={true}
                  paginationPageSize={paginationPageSize}
                  paginationPageSizeSelector={paginationPageSizeSelector}
                />
              </div>
            }
          />
        </Col>

        <Col sm="12" className="mb-3">
          <Widgets
            icon={
              <WidgetsIcon
                icon={<TbReportAnalytics />}
                title="Lost/Damaged Reports"
              />
            }
            button={
              HasPermission("Employee", "create") &&
              <WidgetsButton
                type="button"
                variant="dark"
                text="Add Reports"
                icon={<FiPlus className="btn-icon" />}
                onClick={() => handleFormType("reports")}
              />
            }
            body={
              <Row className="mt-3">
                <Col sm="3">
                  <DownloadCard />
                </Col>
                <Col sm="3">
                  <DownloadCard />
                </Col>
              </Row>
            }
          />
        </Col>
      </Row>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={dialogForm}
        onClose={() => setDialogForm(false)}
        className="dark-bg-color"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={() => setDialogForm(false)}>
              X
            </span>
            <span className="title">
              {formType == "asserts" ? "Add Asserts" : "Add Reports"}
            </span>
          </div>
          <button
            className="universal-btn"
            style={{ padding: "0 15px", borderRadius: "8px", fontSize: "15px" }}
            onClick={preSubmit}
          >
            Add
          </button>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handelSubmit}>
            {formType == "asserts" && (
              <Row className="mt-3">
                <Col sm="6" className="flex-column color-white mt-3">
                  <label>Type</label>
                  <input
                    name={"type"}
                    value={""}
                    placeholder={"Enter type here"}
                    onChange={handelChange}
                    className="universal-input"
                  />
                </Col>

                <Col sm="6" className="flex-column color-white mt-3">
                  <label>Asserts ID</label>
                  <input
                    name={"assertsId"}
                    value={""}
                    placeholder={"Enter asserts id here"}
                    onChange={handelChange}
                    className="universal-input"
                  />
                </Col>

                <Col sm="6" className="flex-column color-white mt-3">
                  <label>Model/Details</label>
                  <input
                    name={"modelDetails"}
                    value={""}
                    placeholder={"Enter model/details here"}
                    onChange={handelChange}
                    className="universal-input"
                  />
                </Col>

                <Col sm="6" className="flex-column color-white mt-3">
                  <label>Issued Date</label>
                  <input
                    type="date"
                    name={"modelDetails"}
                    value={""}
                    onChange={handelChange}
                    className="universal-input"
                  />
                </Col>
              </Row>
            )}

            {formType == "reports" && (
              <div>
                <FileDrop />
              </div>
            )}

            <button
              type="submit"
              id="submit-btn-bs-dt"
              style={{ display: "none" }}
            ></button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CustomDetails;
